// Apple Sign In utility functions
declare global {
  interface Window {
    AppleID?: {
      auth: {
        init: (config: AppleInitConfig) => void;
        signIn: () => Promise<AppleSignInResponse>;
      };
    };
  }
}

interface AppleInitConfig {
  clientId: string;
  scope: string;
  redirectURI?: string;
  state?: string;
  usePopup?: boolean;
}

export interface AppleSignInResponse {
  authorization: {
    code: string;
    id_token: string;
    state: string;
  };
  user?: {
    name: {
      firstName: string;
      lastName: string;
    };
    email: string;
  };
}

export const initAppleSignIn = (clientId: string, redirectURI: string): Promise<void> => {
  // Check if the Apple Sign In script is already loaded
  if (document.getElementById('apple-signin-sdk')) {
    return Promise.resolve();
  }

  // Luôn sử dụng URL production cho cấu hình Apple Sign In
  // Vì Apple chỉ cho phép đăng ký một redirect URL
  
  console.log('Apple Sign In initialization with:', {
    clientId,
    redirectURI
  });

  // Load Apple Sign In JS SDK
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = 'apple-signin-sdk';
    script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;
    script.onload = () => {
      // Initialize AppleID
      if (window.AppleID) {
        try {
          window.AppleID.auth.init({
            clientId,
            scope: 'name email',
            redirectURI,
            state: `${Math.random().toString(36).substring(2, 15)}`, // Random state for security
            usePopup: true
          });
          resolve();
        } catch (error) {
          console.error('Apple Sign In initialization error:', error);
          reject(error);
        }
      } else {
        reject(new Error('Apple Sign In SDK loaded but API not available'));
      }
    };
    script.onerror = () => {
      reject(new Error('Failed to load Apple Sign In SDK'));
    };
    document.head.appendChild(script);
  });
};

export const signInWithApple = async (clientId: string, redirectURI: string): Promise<AppleSignInResponse> => {
  try {
    await initAppleSignIn(clientId, redirectURI);
    
    if (!window.AppleID) {
      throw new Error('Apple Sign In not initialized');
    }
    
    console.log('Starting Apple Sign In process...');
    
    // Perform the sign in
    const response = await window.AppleID.auth.signIn();
    console.log('Apple Sign In response:', response);
    return response;
  } catch (error) {
    console.error('Apple Sign In error:', error);
    throw error;
  }
}; 